<template>
  <div>
    <v-btn
      height="30"
      rounded
      depressed
      color="info"
      :disabled="
        !novopedido.cliente || clienteBloqueado() || getParcelas().length == 0
      "
      :block="isMobile()"
      @click="clickAddProduto()"
    >
      <v-icon left>mdi-cart-plus</v-icon> Adicionar produto</v-btn
    >

    <v-dialog v-model="dialogModel" max-width="1100" persistent scrollable>
      <v-card>
        <v-card-title class="font-weight-bold">Adicionar Produto</v-card-title>
        <v-card-text>
          <v-text-field
            label="Pesquisar produto"
            v-model="pesquisa"
            autofocus
          ></v-text-field>
          <template v-if="isMobile()">
            <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
            <v-alert
              text
              type="info"
              v-else-if="getProdutosFiltrados().length == 0"
              >Nenhum produto encontrado</v-alert
            >
            <v-card
              v-else
              v-for="(prod, i) in getProdutosFiltrados()"
              :key="i"
              flat
              class="grey lighten-4 mt-1"
            >
              <v-card-title class="font-weight-bold subtitle-1"
                >{{ prod.produto }} - {{ prod.emb }}</v-card-title
              >
              <v-card-subtitle class="font-weight-bold pb-2"
                >({{ prod.gp }}-{{ prod.sgp }}-{{ prod.item }})</v-card-subtitle
              >
              <v-card-text>
                <p class="mb-1">
                  Comissão(%)<span class="float-right">{{
                    formatarPercentual(prod.comissaoperc)
                  }}</span>
                </p>
                <p class="mb-1">
                  Acréscimo(%)<span class="float-right">{{
                    formatarPercentual(prod.acrescimoperc)
                  }}</span>
                </p>
                <p class="mb-1">
                  Preço Lista<span class="float-right">{{
                    formatarMoeda(prod.preco)
                  }}</span>
                </p>
                <p class="mb-2">
                  Saldo Contrato<span class="float-right">{{
                    prod.saldofutura
                  }}</span>
                </p>
                <modal-erro-produto
                  v-if="prod.erros && prod.erros.length > 0"
                  :produto="prod"
                />
                <btn-selecionar-produto v-else :produto="prod" />
              </v-card-text>
            </v-card>
          </template>
          <v-data-table
            v-else
            class="mt-2"
            :items="getProdutosFiltrados()"
            :headers="headers"
            no-data-text="Nenhum produto encontrado"
            no-results-text="Nenhum produto localizado com esta pesquisa"
            :loading="loading"
            :items-per-page="5"
            loading-text="Buscando produtos..."
            :sort-by="['produto', 'item']"
            :disable-sort="isMobile()"
          >
            <template v-slot:[`item.comissaoperc`]="{ item }">
              {{ formatarPercentual(item.comissaoperc) }}
            </template>
            <template v-slot:[`item.acrescimoperc`]="{ item }">
              {{ formatarPercentual(item.acrescimoperc) }}
            </template>
            <template v-slot:[`item.preco`]="{ item }">
              {{ formatarMoeda(item.preco, 4) }}
            </template>
            <template v-slot:[`item.qtdepedido`]="{ item }">
              {{ item.qtdepedido }}
            </template>
            <template v-slot:[`item.saldofutura`]="{ item }">
              {{ item.saldofutura }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <modal-erro-produto
                v-if="item.erros && item.erros.length > 0"
                :produto="item"
              />
              <btn-selecionar-produto v-else :produto="item" />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer v-if="!isMobile()"></v-spacer>
          <v-btn
            @click="setDialogProdutos(false)"
            rounded
            text
            color="secondary"
            :block="isMobile()"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { formatMoeda, formatPercentual } from "@/global";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import BtnSelecionarProduto from "./BtnSelecionarProduto.vue";
import ModalErroProduto from "./../ModalErroProduto.vue";
export default {
  components: { BtnSelecionarProduto, ModalErroProduto },
  watch: {
    dialogProdutos: async function (open) {
      if (open) {
        this.loading = true;
        this.pesquisa = "";
        if (this.novopedido.produtos.length == 0) {
          await this.getProdutosEmAberto({
            pesquisa: this.novopedido.cliente.matricula,
          });
          await this.getProdutos();
        }

        this.loading = false;
      }
    },
  },
  computed: {
    ...mapState("pedidos", ["novopedido", "produtos", "dialogProdutos"]),
    ...mapState("base", ["filiais"]),
    ...mapState("clientes", ["produtosEmAberto"]),
    dialogModel: {
      get: function () {
        return this.dialogProdutos;
      },
      set: function (value) {
        this.setDialogProdutos(value);
      },
    },
  },
  data: () => ({
    dialog: false,
    pesquisa: "",
    loading: true,
    headers: [
      { text: "Gp", value: "gp", width: 60 },
      { text: "Sgp", value: "sgp", width: 60 },
      { text: "Item", value: "item", width: 60 },
      { text: "Produto", value: "produto" },
      { text: "Emb", value: "emb" },
      { text: "% Comissão", value: "comissaoperc" },
      { text: "% Acrésc", value: "acrescimoperc" },
      { text: "Preço Lista", value: "preco" },
      //{ text: "Pedido", value: "qtdepedido" },
      { text: "Saldo Contrato", value: "saldofutura" },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  methods: {
    ...mapMutations("pedidos", ["setDialogProdutos"]),
    ...mapActions("pedidos", ["getProdutos", "atualizarDadosProduto"]),
    ...mapActions("clientes", ["getProdutosEmAberto"]),
    ...mapGetters("pedidos", [
      "clienteBloqueado",
      "getParcelas",
      "getTipoPedidoSelec",
      "getCondicaoSelecionada",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value, numDec) {
      return formatMoeda(value, numDec);
    },
    formatarPercentual(value) {
      return formatPercentual(value);
    },
    filialSelecionada() {
      return this.filiais.find((f) => f.filial == this.novopedido.filial);
    },
    getProdutosFiltrados() {
      var prodFiltrados = this.produtos.filter((p) =>
        p.produto.toLowerCase().includes(this.pesquisa.toLowerCase())
      );

      if (this.getTipoPedidoSelec().remessa) {
        return prodFiltrados.filter((p) => p.saldofutura > 0);
      }

      return prodFiltrados;
    },
    clickAddProduto() {
      if (
        this.getCondicaoSelecionada().cartao &&
        this.novopedido.cartaoSelecionado == 0
      ) {
        this.$toasted.error("Por favor, selecione a bandeira do cartão");
        return;
      }
      this.setDialogProdutos(true);
    },
  },
};
</script>

<style>
</style>